// const prefetch = {
//   init() {
//     let throttle = false
//
//     // Mouseover prefetch with throttle
//     document.body.addEventListener('mouseover', (event) => {
//       const target = event.target as HTMLElement
//
//       if (target.tagName !== 'A' || throttle) {
//         return
//       }
//
//       throttle = true
//       setTimeout(() => {
//         prefetch.worker(event)
//         throttle = false
//       }, 200)
//     })
//
//     // IntersectionObserver for link prefetching
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           prefetch.worker({ target: entry.target })
//           observer.unobserve(entry.target) // Stop observing after prefetch
//         }
//       })
//     })
//
//     document.querySelectorAll('a[href^="/"]').forEach((link) => {
//       observer.observe(link) // Watch links that start with /
//     })
//   },
//
//   worker(event) {
//     const target = event.target
//
//     if (target.tagName !== 'A') {
//       return
//     }
//
//     const href = target.getAttribute('href')
//     if (!href || document.head.querySelector(`link[href="${href}"]`)) {
//       return
//     }
//
//     const link = document.createElement('link')
//     link.rel = 'prefetch'
//     link.href = href
//     document.head.appendChild(link)
//   },
// }
//
// export default prefetch

// // OBSERVER PATTERN
const prefetch = {
  init() {
    let throttle = false

    // Mouseover prefetch with throttle
    document.body.addEventListener('mouseover', (event) => {
      const target = event.target as HTMLElement

      if (target.tagName !== 'A' || throttle) {
        return
      }

      throttle = true
      setTimeout(() => {
        prefetch.worker(event)
        throttle = false
      }, 200)
    })

    // IntersectionObserver for link prefetching
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          prefetch.worker({ target: entry.target })
          observer.unobserve(entry.target) // Stop observing after prefetch
        }
      })
    })

    document.querySelectorAll('a[href^="/"]').forEach((link) => {
      observer.observe(link) // Watch links that start with /
    })
  },

  worker(event) {
    const target = event.target

    if (target.tagName !== 'A') {
      return
    }

    const href = target.getAttribute('href')
    if (!href || document.head.querySelector(`link[href="${href}"]`)) {
      return
    }
    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = href
    document.head.appendChild(link)
  },
}

export default prefetch
